<section class="api-key-guide-page">
  <div class="docs-shell">
    <aside class="docs-sidebar" aria-label="API navigation">
      <div class="sidebar-card">
        <h2>API Reference</h2>
        <nav>
          <ul class="sidebar-nav">
            <li>
              <button
                type="button"
                class="sidebar-link sidebar-link--button"
                [class.sidebar-link--active]="isTopLevelActive('get-api-key')"
                (click)="selectTopLevelSection('get-api-key')">
                <span>Get API Key</span>
              </button>
            </li>

            <li class="sidebar-group" [class.sidebar-group--open]="documentsExpanded">
              <div class="sidebar-group-row">
                <button
                  type="button"
                  class="sidebar-link sidebar-link--button"
                  [class.sidebar-link--active]="isTopLevelActive('documents')"
                  (click)="selectTopLevelSection('documents')">
                  <span>Documents</span>
                </button>

                <button
                  type="button"
                  class="sidebar-toggle"
                  [attr.aria-expanded]="documentsExpanded"
                  aria-label="Toggle document navigation"
                  (click)="toggleDocumentsSection()">
                  <span class="sidebar-toggle-icon">⌄</span>
                </button>
              </div>

              @if (documentsExpanded) {
                <ul class="sidebar-subnav">
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('create-document')"
                      (click)="selectDocumentSubSection('create-document')">
                      Create Document
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('update-document')"
                      (click)="selectDocumentSubSection('update-document')">
                      Update Document
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('document-details-status')"
                      (click)="selectDocumentSubSection('document-details-status')">
                      Document Details and Status
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('send-reminders')"
                      (click)="selectDocumentSubSection('send-reminders')">
                      Send Reminders
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('revoke-document')"
                      (click)="selectDocumentSubSection('revoke-document')">
                      Revoke Document
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('send-document-from-template')"
                      (click)="selectDocumentSubSection('send-document-from-template')">
                      Send Document from Template
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('download-document')"
                      (click)="selectDocumentSubSection('download-document')">
                      Download Document
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('delete-document')"
                      (click)="selectDocumentSubSection('delete-document')">
                      Delete Document
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('embedded-configure-fields')"
                      (click)="selectDocumentSubSection('embedded-configure-fields')">
                      Embedded Configure Fields
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isDocumentSubSectionActive('refresh-configure-url')"
                      (click)="selectDocumentSubSection('refresh-configure-url')">
                      Refresh Configure URL
                    </button>
                  </li>
                </ul>
              }
            </li>

            <li class="sidebar-group" [class.sidebar-group--open]="templatesExpanded">
              <div class="sidebar-group-row">
                <button
                  type="button"
                  class="sidebar-link sidebar-link--button"
                  [class.sidebar-link--active]="isTopLevelActive('templates')"
                  (click)="selectTopLevelSection('templates')">
                  <span>Templates</span>
                </button>

                <button
                  type="button"
                  class="sidebar-toggle"
                  [attr.aria-expanded]="templatesExpanded"
                  aria-label="Toggle template navigation"
                  (click)="toggleTemplatesSection()">
                  <span class="sidebar-toggle-icon">⌄</span>
                </button>
              </div>

              @if (templatesExpanded) {
                <ul class="sidebar-subnav">
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('create-template')"
                      (click)="selectTemplateSubSection('create-template')">
                      Create Template
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('update-template')"
                      (click)="selectTemplateSubSection('update-template')">
                      Update Template
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('template-details')"
                      (click)="selectTemplateSubSection('template-details')">
                      Template Details
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('delete-template')"
                      (click)="selectTemplateSubSection('delete-template')">
                      Delete Template
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('embedded-template-configure-fields')"
                      (click)="selectTemplateSubSection('embedded-template-configure-fields')">
                      Embedded Configure Fields
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isTemplateSubSectionActive('refresh-template-configure-url')"
                      (click)="selectTemplateSubSection('refresh-template-configure-url')">
                      Refresh Configure URL
                    </button>
                  </li>
                </ul>
              }
            </li>

            <li class="sidebar-group" [class.sidebar-group--open]="senderIdentitiesExpanded">
              <div class="sidebar-group-row">
                <button
                  type="button"
                  class="sidebar-link sidebar-link--button"
                  [class.sidebar-link--active]="isTopLevelActive('sender-identities')"
                  (click)="selectTopLevelSection('sender-identities')">
                  <span>Sender Identities</span>
                </button>

                <button
                  type="button"
                  class="sidebar-toggle"
                  [attr.aria-expanded]="senderIdentitiesExpanded"
                  aria-label="Toggle sender identity navigation"
                  (click)="toggleSenderIdentitiesSection()">
                  <span class="sidebar-toggle-icon">⌄</span>
                </button>
              </div>

              @if (senderIdentitiesExpanded) {
                <ul class="sidebar-subnav">
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isSenderIdentitySubSectionActive('create-sender-identity')"
                      (click)="selectSenderIdentitySubSection('create-sender-identity')">
                      Create Sender Identity
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isSenderIdentitySubSectionActive('update-sender-identity')"
                      (click)="selectSenderIdentitySubSection('update-sender-identity')">
                      Update Sender Identity
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isSenderIdentitySubSectionActive('resend-sender-identity-invitation')"
                      (click)="selectSenderIdentitySubSection('resend-sender-identity-invitation')">
                      Resend Invitation
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isSenderIdentitySubSectionActive('rerequest-sender-identity-approval')"
                      (click)="selectSenderIdentitySubSection('rerequest-sender-identity-approval')">
                      Rerequest Approval
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isSenderIdentitySubSectionActive('delete-sender-identity')"
                      (click)="selectSenderIdentitySubSection('delete-sender-identity')">
                      Delete Sender Identity
                    </button>
                  </li>
                </ul>
              }
            </li>

            <li class="sidebar-group" [class.sidebar-group--open]="brandsExpanded">
              <div class="sidebar-group-row">
                <button
                  type="button"
                  class="sidebar-link sidebar-link--button"
                  [class.sidebar-link--active]="isTopLevelActive('brands')"
                  (click)="selectTopLevelSection('brands')">
                  <span>Brands</span>
                </button>

                <button
                  type="button"
                  class="sidebar-toggle"
                  [attr.aria-expanded]="brandsExpanded"
                  aria-label="Toggle brand navigation"
                  (click)="toggleBrandsSection()">
                  <span class="sidebar-toggle-icon">⌄</span>
                </button>
              </div>

              @if (brandsExpanded) {
                <ul class="sidebar-subnav">
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isBrandSubSectionActive('list-brands')"
                      (click)="selectBrandSubSection('list-brands')">
                      List Brands
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isBrandSubSectionActive('create-brand')"
                      (click)="selectBrandSubSection('create-brand')">
                      Create Brand
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isBrandSubSectionActive('update-brand')"
                      (click)="selectBrandSubSection('update-brand')">
                      Update Brand
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isBrandSubSectionActive('delete-brand')"
                      (click)="selectBrandSubSection('delete-brand')">
                      Delete Brand
                    </button>
                  </li>
                </ul>
              }
            </li>

            <li class="sidebar-group" [class.sidebar-group--open]="webhooksExpanded">
              <div class="sidebar-group-row">
                <button
                  type="button"
                  class="sidebar-link sidebar-link--button"
                  [class.sidebar-link--active]="isTopLevelActive('webhooks')"
                  (click)="selectTopLevelSection('webhooks')">
                  <span>Webhooks</span>
                </button>

                <button
                  type="button"
                  class="sidebar-toggle"
                  [attr.aria-expanded]="webhooksExpanded"
                  aria-label="Toggle webhook navigation"
                  (click)="toggleWebhooksSection()">
                  <span class="sidebar-toggle-icon">⌄</span>
                </button>
              </div>

              @if (webhooksExpanded) {
                <ul class="sidebar-subnav">
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isWebhookSubSectionActive('webhooks-overview')"
                      (click)="selectWebhookSubSection('webhooks-overview')">
                      Overview
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isWebhookSubSectionActive('document-events')"
                      (click)="selectWebhookSubSection('document-events')">
                      Document Events
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isWebhookSubSectionActive('sender-identity-events')"
                      (click)="selectWebhookSubSection('sender-identity-events')">
                      Sender Identity Events
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="sidebar-sublink"
                      [class.sidebar-sublink--active]="isWebhookSubSectionActive('template-events')"
                      (click)="selectWebhookSubSection('template-events')">
                      Template Events
                    </button>
                  </li>
                </ul>
              }
            </li>
          </ul>
        </nav>
      </div>
    </aside>

    <main class="docs-content">
      <nav class="breadcrumb-nav" aria-label="Breadcrumb">
        <ol class="breadcrumb-list">
          @for (crumb of breadcrumbs; track crumb; let isLast = $last) {
            <li class="breadcrumb-item">
              <span [class.breadcrumb-current]="isLast">{{ crumb }}</span>
            </li>
          }
        </ol>
      </nav>

      @if (activeSection === 'get-api-key') {
        <article class="docs-article" data-section="get-api-key">
          <header class="article-header" id="api-key-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Get API Key</h1>
            <p class="article-intro">
              Generate a sandbox or live API key before calling any public document endpoint. Use the key as a Bearer
              token in the <code>Authorization</code> header.
            </p>

            <div class="overview-list" aria-label="API key overview">
              @for (item of apiKeyOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="prerequisites-title" id="prerequisites">
            <div class="section-heading">
              <p class="section-kicker">Before you start</p>
              <h2 id="prerequisites-title">Prerequisites</h2>
            </div>

            <p class="section-copy">
              You need access to the product dashboard. Create an account or sign in before generating an API key.
            </p>

            <div class="section-actions">
              <a routerLink="/signup" class="primary-link">Create account</a>
              <a routerLink="/login" class="secondary-link">Sign in</a>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="get-api-key-title" id="get-api-key">
            <div class="section-heading">
              <p class="section-kicker">Setup</p>
              <h2 id="get-api-key-title">Get API Key</h2>
            </div>

            <p class="section-copy">
              Generate the key in the dashboard and copy it immediately after creation.
            </p>

            <ol class="steps-list">
              @for (step of steps; track step.title; let index = $index) {
                <li class="step-card">
                  <span class="step-index" aria-hidden="true">{{ index + 1 }}</span>
                  <div>
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.detail }}</p>
                  </div>
                </li>
              }
            </ol>
          </section>

          <section class="docs-section" aria-labelledby="key-handling-title" id="key-handling">
            <div class="section-heading">
              <p class="section-kicker">Security</p>
              <h2 id="key-handling-title">Key handling</h2>
            </div>

            <div class="note-grid">
              @for (note of notes; track note.title) {
                <article class="note-card">
                  <h3>{{ note.title }}</h3>
                  <p>{{ note.detail }}</p>
                </article>
              }
            </div>
          </section>

          <footer class="guide-footer">
            <p>Use the generated key in the Bearer header when calling the public document API.</p>
            <div class="footer-actions">
              <a routerLink="/login" class="secondary-link">Back to login</a>
              <a routerLink="/signup" class="primary-link">Sign up</a>
            </div>
          </footer>
        </article>
      }

      @if (activeSection === 'documents') {
        <article class="docs-article" data-section="documents">
          <header class="article-header" id="documents-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Documents</h1>
            <p class="article-intro">
              Create draft documents from uploaded PDFs, send documents from saved templates, download final signed
              PDFs, configure fields in an embedded public UI, and refresh the configure URL later by
              <code>documentId</code>.
            </p>

            <div class="api-meta-panel" aria-label="Endpoint metadata">
              @for (item of apiMeta; track item.label) {
                <div class="meta-row">
                  <span class="meta-label">{{ item.label }}</span>
                  <span class="meta-value">{{ item.value }}</span>
                </div>
              }
            </div>

            <div class="overview-list" aria-label="Documents overview">
              @for (item of documentOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="create-document-title" id="create-document">
            <div class="section-heading">
              <p class="section-kicker">Step 1</p>
              <h2 id="create-document-title">Create Document</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to upload the source PDF, define recipients and document settings, and create a draft
              without fields. Field placement happens in the next step through <code>configureFieldsUrl</code>.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of createDocumentChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="callout callout--info">
              <strong>Request format</strong>
              <p>
                Send the request as <code>multipart/form-data</code> with a required <code>file</code> part and a
                required <code>payload</code> JSON string.
              </p>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="update-document-title" id="update-document">
            <div class="section-heading">
              <p class="section-kicker">Manage</p>
              <h2 id="update-document-title">Update Document</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to update step-1 document data after creation. Updates are partial, only `draft`
              documents are editable, and field placement continues through the existing configure-fields flow.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of updateDocumentChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="update-document-params-title">
                <h3 id="update-document-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of updateDocumentParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="update-document-fields-title">
                <h3 id="update-document-fields-title">Supported request fields</h3>
                <div class="field-list">
                  @for (item of updateDocumentFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--warning">
              <strong>Draft-only partial updates</strong>
              <p>
                Send only the step-1 fields you want to change. Validation still runs against the effective merged
                draft state, so recipient uniqueness, valid emails, valid document title, and brand ownership must
                remain valid after the update.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ updateDocumentEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ updateDocumentRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response fields</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <div class="field-list">
                  @for (item of updateDocumentResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ updateDocumentResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of updateDocumentErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="document-details-status-title" id="document-details-status">
            <div class="section-heading">
              <p class="section-kicker">Lookup</p>
              <h2 id="document-details-status-title">Document Details and Status</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to fetch the current document status together with public-safe document details,
              recipient progress, timeline history, source-file metadata, and final signed file metadata when
              available.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of documentDetailsChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="document-details-params-title">
                <h3 id="document-details-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of documentDetailsParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="document-details-response-fields-title">
                <h3 id="document-details-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of documentDetailsResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Public-safe response only</strong>
              <p>
                The public API excludes internal signing and authentication fields such as token hashes, delivery
                failure internals, and recipient authentication counters. Completed documents may include
                <code>finalSignedFile</code>; in-progress documents may not.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ documentDetailsEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ documentDetailsResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of documentDetailsErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="send-reminders-title" id="send-reminders">
            <div class="section-heading">
              <p class="section-kicker">Recipient follow-up</p>
              <h2 id="send-reminders-title">Send Reminders</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to queue reminder emails for all recipients on the same document who are currently
              eligible to be reminded. One request can remind multiple recipients together.
            </p>

            <p class="section-copy">
              Recipient eligibility is decided by the API from the current document and recipient lifecycle state.
              When signing order is enabled, reminders are queued only for the next actionable signer or signers.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of sendRemindersChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="send-reminders-params-title">
                <h3 id="send-reminders-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of sendRemindersParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="send-reminders-response-fields-title">
                <h3 id="send-reminders-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of sendRemindersResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Queueing does not equal delivery</strong>
              <p>
                A successful response means reminder jobs were queued. It does not guarantee that downstream email
                delivery will succeed for every recipient.
              </p>
            </div>

            <div class="callout callout--info">
              <strong>No request body is required</strong>
              <p>
                Send the API key header and the target <code>documentId</code>. The API determines which recipients
                can be reminded right now.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ sendRemindersEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ sendRemindersResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of sendRemindersErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="revoke-document-title" id="revoke-document">
            <div class="section-heading">
              <p class="section-kicker">Sender control</p>
              <h2 id="revoke-document-title">Revoke Document</h2>
            </div>

            <p class="section-copy">
              Use this endpoint when the sender needs to call off the signing process. Once revoked, recipients can no
              longer view or sign the document.
            </p>

            <p class="section-copy">
              Revoke is available only while the document is not already in a terminal state. You may optionally send
              a <code>reason</code> that is stored on the revoked document and included in its status context.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of revokeDocumentChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="revoke-document-params-title">
                <h3 id="revoke-document-params-title">Required parameters, headers, and request body</h3>
                <div class="field-list">
                  @for (item of revokeDocumentParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="revoke-document-response-fields-title">
                <h3 id="revoke-document-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of revokeDocumentResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Revocation confirms the state change</strong>
              <p>
                A successful response confirms that the document was revoked and that notification work was queued. It
                does not guarantee downstream email delivery success.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ revokeDocumentEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ revokeDocumentRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ revokeDocumentResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of revokeDocumentErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section
            class="docs-section"
            aria-labelledby="send-document-from-template-title"
            id="send-document-from-template">
            <div class="section-heading">
              <p class="section-kicker">Template send</p>
              <h2 id="send-document-from-template-title">Send Document from Template</h2>
            </div>

            <p class="section-copy">
              Use this route when the template already contains the PDF and configured fields. Provide the stored
              <code>templateId</code>, map real recipients to each template <code>roleId</code>, and optionally
              override common defaults such as title, message, CC emails, tags, document settings, signing order, or
              <code>sendAt</code>.
            </p>

            <p class="section-copy">
              Branding for this route is supplied through <code>documentSettings.brandId</code>. The selected brand
              customizes signature-request emails and document signing pages. You can obtain <code>brandId</code> from
              the public Brands API or copy it from the web app.
            </p>

            <p class="section-copy">
              Use <code>onBehalfOf</code> when the document should be sent on behalf of another user. The value must
              be a verified sender-identity email owned by the same API-key owner. All document emails for that sent
              document use the selected sender identity.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of sendFromTemplateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="send-from-template-params-title">
                <h3 id="send-from-template-params-title">Required parameters and supported overrides</h3>
                <div class="field-list">
                  @for (item of sendFromTemplateParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="send-from-template-response-fields-title">
                <h3 id="send-from-template-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of sendFromTemplateResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Template inheritance</strong>
              <p>
                The API inherits the template source file, fields, role metadata, and saved defaults. If you supply
                <code>documentSettings.brandId</code>, it overrides the template brand for the sent document. This
                route sends directly, so it does not return <code>configureFieldsUrl</code>.
              </p>
            </div>

            <div class="callout callout--info">
              <strong>Finding your brand id</strong>
              <p>
                Use <code>Brands &gt; List Brands</code> or <code>Brands &gt; Create Brand</code> to obtain a reusable
                <code>brandId</code>. The same id can be used later in document, template, and sender-identity API
                requests.
              </p>
            </div>

            <div class="callout callout--info">
              <strong>Verified sender identity required</strong>
              <p>
                Manage sender identities under <code>Sender Identities</code>. <code>onBehalfOf</code> accepts only a
                verified sender-identity email. Pending or denied sender identities are rejected.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ sendFromTemplateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ sendFromTemplateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ sendFromTemplateResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of sendFromTemplateErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="download-document-title" id="download-document">
            <div class="section-heading">
              <p class="section-kicker">Final signed file</p>
              <h2 id="download-document-title">Download Document</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to download the final signed PDF for a completed document. The route returns the final
              generated PDF only after signing is complete and final PDF generation is done.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of downloadDocumentChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="download-document-params-title">
                <h3 id="download-document-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of downloadDocumentParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="download-document-response-fields-title">
                <h3 id="download-document-response-fields-title">Response behavior</h3>
                <div class="field-list">
                  @for (item of downloadDocumentResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Final signed PDF only</strong>
              <p>
                This route does not return the original uploaded PDF. If the document is not completed yet, or final
                PDF generation is still in progress, the API returns <code>409 Final signed PDF is not available yet</code>.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ downloadDocumentEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response example</h3>
                  <span class="code-chip">PDF</span>
                </div>
                <pre><code>{{ downloadDocumentResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of downloadDocumentErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="delete-document-title" id="delete-document">
            <div class="section-heading">
              <p class="section-kicker">Trash</p>
              <h2 id="delete-document-title">Delete Document</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to move an owned document to trash through a soft delete. The route sets
              <code>deletedAt</code> and removes the document from active lookups, but it does not permanently erase
              the record or delete stored files.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of deleteDocumentChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="delete-document-params-title">
                <h3 id="delete-document-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of deleteDocumentParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="delete-document-response-title">
                <h3 id="delete-document-response-title">Response behavior</h3>
                <div class="field-list">
                  @for (item of deleteDocumentResponseNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--warning">
              <strong>Eligible statuses only</strong>
              <p>
                This public route accepts only <code>draft</code>, <code>completed</code>, and <code>expired</code>
                documents. Active in-flight documents are rejected with
                <code>409 Only draft/completed/expired documents can be deleted</code>.
              </p>
            </div>

            <div class="callout callout--info">
              <strong>Soft delete only</strong>
              <p>
                This endpoint is not a permanent delete API. It moves the document to trash and leaves permanent file
                cleanup out of scope for this public route.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ deleteDocumentEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of deleteDocumentErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="required-fields-title" id="required-fields">
            <div class="section-heading">
              <p class="section-kicker">Required fields</p>
              <h2 id="required-fields-title">What your request must include</h2>
            </div>

            <div class="highlight-grid highlight-grid--compact">
              @for (item of requiredPayloadHighlights; track item.title) {
                <article class="highlight-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="top-level-fields-title">
                <h3 id="top-level-fields-title">Top-level request fields</h3>
                <div class="field-list">
                  @for (item of topLevelFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="recipient-fields-title">
                <h3 id="recipient-fields-title">Recipient object fields</h3>
                <div class="field-list">
                  @for (item of recipientFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="document-fields-title">
                <h3 id="document-fields-title">Document object fields</h3>
                <div class="field-list">
                  @for (item of documentFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="document-settings-fields-title">
                <h3 id="document-settings-fields-title">Document settings fields</h3>
                <div class="field-list">
                  @for (item of documentSettingsFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--warning">
              <strong>Auto-generated values</strong>
              <p>
                <code>recipient.id</code> and <code>recipient.roleId</code> are optional. The backend generates them
                automatically when omitted.
              </p>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="request-response-title" id="request-response">
            <div class="section-heading">
              <p class="section-kicker">Reference</p>
              <h2 id="request-response-title">Request and response</h2>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ endpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Payload field JSON</h3>
                  <span class="code-chip">payload</span>
                </div>
                <pre><code>{{ requestExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Example response</h3>
                <span class="code-chip">JSON</span>
              </div>
              <pre><code>{{ responseExample }}</code></pre>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="embedded-configure-fields-title" id="embedded-configure-fields">
            <div class="section-heading">
              <p class="section-kicker">Step 2</p>
              <h2 id="embedded-configure-fields-title">Embedded Configure Fields</h2>
            </div>

            <p class="section-copy">
              Load <code>configureFieldsUrl</code> in an iframe to open the public field configuration UI for the
              created document draft.
            </p>

            <div class="info-grid">
              @for (item of embedGuideItems; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </section>

          <section class="docs-section" aria-labelledby="refresh-configure-url-title" id="refresh-configure-url">
            <div class="section-heading">
              <p class="section-kicker">Follow-up</p>
              <h2 id="refresh-configure-url-title">Refresh Configure URL</h2>
            </div>

            <p class="section-copy">
              Use the refresh endpoint when you need a new embedded configure URL for an existing document. Draft
              documents remain editable. Sent and finalized documents open in read-only mode.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of refreshConfigureUrlChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="refresh-params-title">
                <h3 id="refresh-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of refreshConfigureUrlParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="refresh-response-fields-title">
                <h3 id="refresh-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of refreshConfigureUrlResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Request body</strong>
              <p>
                No request body is required by the backend. Clients may send an empty JSON object, but no payload
                fields are read by this endpoint.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Refresh endpoint</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ refreshEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ refreshRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Refresh response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ refreshResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of refreshConfigureUrlErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>

            <section class="docs-section" aria-labelledby="update-sender-identity-title" id="update-sender-identity">
              <div class="section-heading">
                <p class="section-kicker">Update</p>
                <h2 id="update-sender-identity-title">Update Sender Identity</h2>
              </div>

              <p class="section-copy">
                Use this endpoint to update the sender identity display name and optional brand association. Email
                changes are not supported in v1.
              </p>

              <div class="info-grid info-grid--compact">
                @for (item of senderIdentityUpdateChecklist; track item.title) {
                  <article class="info-card">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>

              <section class="reference-card" aria-labelledby="sender-identity-update-fields-title">
                <h3 id="sender-identity-update-fields-title">Parameters and supported fields</h3>
                <div class="field-list">
                  @for (item of senderIdentityUpdateFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <div class="code-grid">
                <article class="code-card">
                  <div class="code-card-header">
                    <h3>Endpoint and auth</h3>
                    <span class="code-chip">HTTP</span>
                  </div>
                  <pre><code>{{ senderIdentityUpdateEndpointExample }}</code></pre>
                </article>

                <article class="code-card">
                  <div class="code-card-header">
                    <h3>Request body</h3>
                    <span class="code-chip">JSON</span>
                  </div>
                  <pre><code>{{ senderIdentityUpdateRequestExample }}</code></pre>
                </article>
              </div>

              <div class="code-grid">
                <article class="code-card">
                  <div class="code-card-header">
                    <h3>Example response</h3>
                    <span class="code-chip">JSON</span>
                  </div>
                  <pre><code>{{ senderIdentityResponseExample }}</code></pre>
                </article>

                <article class="code-card">
                  <div class="code-card-header">
                    <h3>Error responses</h3>
                    <span class="code-chip">Notes</span>
                  </div>
                  <div class="field-list">
                    @for (item of senderIdentityUpdateErrorNotes; track item.title) {
                      <article class="field-row">
                        <div class="field-row-heading">
                          <code>{{ item.title }}</code>
                        </div>
                        <p>{{ item.detail }}</p>
                      </article>
                    }
                  </div>
                </article>
              </div>
            </section>
          </section>

          <footer class="guide-footer">
            <p>Store the returned <code>documentId</code> so you can reopen or refresh the public configure flow later.</p>
          </footer>
        </article>
      }

      @if (activeSection === 'templates') {
        <article class="docs-article" data-section="templates">
          <header class="article-header" id="templates-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Templates</h1>
            <p class="article-intro">
              Create a reusable template from an uploaded PDF, configure fields in an embedded public UI, and refresh
              the template configure URL later by <code>templateId</code>.
            </p>

            <div class="api-meta-panel" aria-label="Template endpoint metadata">
              @for (item of templateApiMeta; track item.label) {
                <div class="meta-row">
                  <span class="meta-label">{{ item.label }}</span>
                  <span class="meta-value">{{ item.value }}</span>
                </div>
              }
            </div>

            <div class="overview-list" aria-label="Templates overview">
              @for (item of templateOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="create-template-title" id="create-template">
            <div class="section-heading">
              <p class="section-kicker">Step 1</p>
              <h2 id="create-template-title">Create Template</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to upload the source PDF, define template roles and settings, and create the template
              before or alongside field configuration.
            </p>

            <div class="callout callout--info">
              <strong>Draft lifecycle</strong>
              <p>
                Step 1 stores the template as <code>draft</code>. The template becomes <code>created</code> only after
                the embedded configure-fields flow saves fields successfully.
              </p>
            </div>

            <div class="info-grid info-grid--compact">
              @for (item of createTemplateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="callout callout--info">
              <strong>Request format</strong>
              <p>
                Send the request as <code>multipart/form-data</code> with a required <code>file</code> part and a
                required <code>payload</code> JSON string.
              </p>
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="create-template-parts-title">
                <h3 id="create-template-parts-title">Required multipart parts</h3>
                <div class="field-list">
                  @for (item of createTemplateRequestParts; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="create-template-payload-fields-title">
                <h3 id="create-template-payload-fields-title">Payload fields</h3>
                <div class="field-list">
                  @for (item of createTemplatePayloadFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--warning">
              <strong>Fields can be configured later</strong>
              <p>
                <code>fields</code> may be empty for public template create. If you omit fields or send an empty
                array, continue field placement later through <code>configureFieldsUrl</code>. If fields are provided,
                they must reference known roles and stay within the uploaded PDF page count, but the template still
                remains <code>draft</code> until the configure-fields step is saved successfully.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ templateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Payload JSON</h3>
                  <span class="code-chip">payload</span>
                </div>
                <pre><code>{{ templateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ templateResponseExample }}</code></pre>
              </article>
            </div>

          </section>

          <section class="docs-section" aria-labelledby="update-template-title" id="update-template">
            <div class="section-heading">
              <p class="section-kicker">Manage</p>
              <h2 id="update-template-title">Update Template</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to update template data after creation. Updates are partial, ownership is validated
              against the API key owner, and the stored source PDF remains unchanged in v1.
            </p>

            <div class="callout callout--warning">
              <strong>Creation still happens in configure fields</strong>
              <p>
                Updating a draft template here does not emit <code>template.created</code>. That event fires only when
                the embedded configure-fields flow first promotes the draft to <code>created</code>.
              </p>
            </div>

            <div class="info-grid info-grid--compact">
              @for (item of updateTemplateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="update-template-params-title">
                <h3 id="update-template-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of updateTemplateParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="update-template-fields-title">
                <h3 id="update-template-fields-title">Supported request fields</h3>
                <div class="field-list">
                  @for (item of updateTemplateFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--warning">
              <strong>Partial update behavior</strong>
              <p>
                Send only the fields you want to change. Validation still runs against the effective merged template
                state, so roles, fields, page bounds, and brand ownership must remain valid after the update.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ templateUpdateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ templateUpdateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response fields</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <div class="field-list">
                  @for (item of updateTemplateResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ templateUpdateResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of updateTemplateErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="template-details-title" id="template-details">
            <div class="section-heading">
              <p class="section-kicker">Read</p>
              <h2 id="template-details-title">Template Details</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to fetch the template&apos;s entire saved details, including its title, description,
              roles, added form fields, and related settings, by specifying the owned <code>templateId</code>.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of templateDetailsChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="template-details-params-title">
                <h3 id="template-details-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of templateDetailsParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="template-details-response-fields-title">
                <h3 id="template-details-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of templateDetailsResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Full saved definition</strong>
              <p>
                The response returns the complete saved template definition for the API-key owner, including
                <code>roles</code>, <code>fields</code>, <code>document</code>, <code>usageSettings</code>, and
                <code>documentSettings</code>.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ templateDetailsEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ templateDetailsResponseExample }}</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of templateDetailsErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="delete-template-title" id="delete-template">
            <div class="section-heading">
              <p class="section-kicker">Trash</p>
              <h2 id="delete-template-title">Delete Template</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to soft-delete an owned template through the public API. The route sets
              <code>deletedAt</code>, removes the template from active lookups, and emits the existing
              <code>template.deleted</code> webhook event.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of deleteTemplateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="delete-template-params-title">
                <h3 id="delete-template-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of deleteTemplateParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="delete-template-response-title">
                <h3 id="delete-template-response-title">Response behavior</h3>
                <div class="field-list">
                  @for (item of deleteTemplateResponseNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>No request body</strong>
              <p>This endpoint does not require a request body and returns <code>204 No Content</code> on success.</p>
            </div>

            <div class="callout callout--warning">
              <strong>Soft delete only</strong>
              <p>
                Delete removes the template from active public API access but does not hard-delete the record or erase
                the stored source file as part of this route.
              </p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ deleteTemplateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of deleteTemplateErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section
            class="docs-section"
            aria-labelledby="embedded-template-configure-fields-title"
            id="embedded-template-configure-fields">
            <div class="section-heading">
              <p class="section-kicker">Step 2</p>
              <h2 id="embedded-template-configure-fields-title">Embedded Configure Fields</h2>
            </div>

            <p class="section-copy">
              Load <code>configureFieldsUrl</code> in an iframe to open the public template field editor for the
              created template.
            </p>

            <div class="info-grid">
              @for (item of templateEmbedGuideItems; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </section>

          <section
            class="docs-section"
            aria-labelledby="refresh-template-configure-url-title"
            id="refresh-template-configure-url">
            <div class="section-heading">
              <p class="section-kicker">Follow-up</p>
              <h2 id="refresh-template-configure-url-title">Refresh Configure URL</h2>
            </div>

            <p class="section-copy">
              Use the refresh endpoint when you need a new embedded configure URL for an existing template. Refreshed
              template configure URLs remain editable while the template exists.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of refreshTemplateConfigureUrlChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="refresh-template-params-title">
                <h3 id="refresh-template-params-title">Required parameters and headers</h3>
                <div class="field-list">
                  @for (item of refreshTemplateConfigureUrlParams; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="refresh-template-response-fields-title">
                <h3 id="refresh-template-response-fields-title">Response fields</h3>
                <div class="field-list">
                  @for (item of refreshTemplateConfigureUrlResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="callout callout--info">
              <strong>Request body</strong>
              <p>No request body is required by the backend for this endpoint.</p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Refresh endpoint</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ templateRefreshEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <pre><code>{{ templateRefreshRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Refresh response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ templateRefreshResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of refreshTemplateConfigureUrlErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <footer class="guide-footer">
            <p>Store the returned <code>templateId</code> so you can reopen or refresh the public template configure flow later.</p>
          </footer>
        </article>
      }

      @if (activeSection === 'sender-identities') {
        <article class="docs-article" data-section="sender-identities">
          <header class="article-header" id="sender-identities-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Sender Identities</h1>
            <p class="article-intro">
              Create a sender identity when an integration needs approval to send documents on behalf of another email
              address. New sender identities begin in <code>pending</code> status and continue through the existing
              approval flow.
            </p>

            <div class="overview-list" aria-label="Sender identities overview">
              @for (item of senderIdentityOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="create-sender-identity-title" id="create-sender-identity">
            <div class="section-heading">
              <p class="section-kicker">Create</p>
              <h2 id="create-sender-identity-title">Create Sender Identity</h2>
            </div>

            <p class="section-copy">
              This v1 endpoint supports the current product create flow: name, email, and optional brand selection.
              It does not document unsupported parity fields such as <code>redirectUrl</code>, <code>metadata</code>,
              <code>locale</code>, or create-time notification settings.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of senderIdentityCreateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <div class="reference-grid">
              <section class="reference-card" aria-labelledby="sender-identity-fields-title">
                <h3 id="sender-identity-fields-title">Request fields</h3>
                <div class="field-list">
                  @for (item of senderIdentityCreateFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>

              <section class="reference-card" aria-labelledby="sender-identity-response-title">
                <h3 id="sender-identity-response-title">Response fields</h3>
                <div class="field-list">
                  @for (item of senderIdentityResponseFields; track item.field) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.field }}</code>
                        <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                          {{ item.status }}
                        </span>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </section>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ senderIdentityEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ senderIdentityRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ senderIdentityResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of senderIdentityErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="update-sender-identity-title" id="update-sender-identity">
            <div class="section-heading">
              <p class="section-kicker">Update</p>
              <h2 id="update-sender-identity-title">Update Sender Identity</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to update the sender identity display name and optional brand association. Email
              changes are not supported in v1.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of senderIdentityUpdateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="sender-identity-update-fields-title">
              <h3 id="sender-identity-update-fields-title">Parameters and supported fields</h3>
              <div class="field-list">
                @for (item of senderIdentityUpdateFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ senderIdentityUpdateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ senderIdentityUpdateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ senderIdentityResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of senderIdentityUpdateErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section
            class="docs-section"
            aria-labelledby="resend-sender-identity-invitation-title"
            id="resend-sender-identity-invitation">
            <div class="section-heading">
              <p class="section-kicker">Resend</p>
              <h2 id="resend-sender-identity-invitation-title">Resend Invitation</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to resend the approval invitation email for a sender identity that is still
              <code>pending</code>. The sender identity is resolved by the API-key owner and the required
              <code>email</code> query parameter.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of senderIdentityResendChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="sender-identity-resend-fields-title">
              <h3 id="sender-identity-resend-fields-title">Required query parameter and header</h3>
              <div class="field-list">
                @for (item of senderIdentityResendFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="callout callout--info">
              <strong>Request body</strong>
              <p>No request body is required by this endpoint.</p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ senderIdentityResendEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>204 No Content</code></pre>
              </article>
            </div>

            <article class="code-card">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of senderIdentityResendErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section
            class="docs-section"
            aria-labelledby="rerequest-sender-identity-approval-title"
            id="rerequest-sender-identity-approval">
            <div class="section-heading">
              <p class="section-kicker">Rerequest</p>
              <h2 id="rerequest-sender-identity-approval-title">Rerequest Approval</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to reopen approval after the recipient explicitly declined the sender identity request.
              Unlike <code>Resend Invitation</code>, this endpoint applies only to sender identities in
              <code>denied</code> status.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of senderIdentityRerequestChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="sender-identity-rerequest-fields-title">
              <h3 id="sender-identity-rerequest-fields-title">Required query parameter and header</h3>
              <div class="field-list">
                @for (item of senderIdentityRerequestFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="callout callout--info">
              <strong>Request body</strong>
              <p>No request body is required by this endpoint.</p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ senderIdentityRerequestEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>204 No Content</code></pre>
              </article>
            </div>

            <article class="code-card">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of senderIdentityRerequestErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <section class="docs-section" aria-labelledby="delete-sender-identity-title" id="delete-sender-identity">
            <div class="section-heading">
              <p class="section-kicker">Delete</p>
              <h2 id="delete-sender-identity-title">Delete Sender Identity</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to permanently remove an owned sender identity. No request body is required.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of senderIdentityDeleteChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="sender-identity-delete-fields-title">
              <h3 id="sender-identity-delete-fields-title">Required parameters and headers</h3>
              <div class="field-list">
                @for (item of senderIdentityDeleteFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="callout callout--info">
              <strong>Request body</strong>
              <p>No request body is required by this endpoint.</p>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ senderIdentityDeleteEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>204 No Content</code></pre>
              </article>
            </div>

            <article class="code-card code-card--full">
              <div class="code-card-header">
                <h3>Error responses</h3>
                <span class="code-chip">Notes</span>
              </div>
              <div class="field-list">
                @for (item of senderIdentityDeleteErrorNotes; track item.title) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.title }}</code>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </article>
          </section>

          <footer class="guide-footer">
            <p>Store the returned sender identity id and wait for approval before using the sender identity in send-on-behalf-of flows.</p>
          </footer>
        </article>
      }

      @if (activeSection === 'brands') {
        <article class="docs-article" data-section="brands">
          <header class="article-header" id="brands-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Brands</h1>
            <p class="article-intro">
              Create brands for your organization account and store the returned <code>brandId</code> for later use
              in documents, templates, and sender identities that support brand selection.
            </p>

            <div class="overview-list" aria-label="Brands overview">
              @for (item of brandOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="list-brands-title" id="list-brands">
            <div class="section-heading">
              <p class="section-kicker">List</p>
              <h2 id="list-brands-title">List Brands</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to fetch all brands available to the API-key owner account. The response returns a
              pageless brand list with default brands first, followed by remaining brands in newest-first order.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of brandListChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="brand-list-fields-title">
              <h3 id="brand-list-fields-title">Response fields</h3>
              <div class="field-list">
                @for (item of brandListResponseFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ brandListEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ brandListResponseExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of brandListErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="create-brand-title" id="create-brand">
            <div class="section-heading">
              <p class="section-kicker">Create</p>
              <h2 id="create-brand-title">Create Brand</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to create a new brand under the API-key owner account. The returned
              <code>brandId</code> can be passed later when creating documents, templates, or sender identities.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of brandCreateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="brand-create-fields-title">
              <h3 id="brand-create-fields-title">Request fields</h3>
              <div class="field-list">
                @for (item of brandCreateFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ brandCreateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ brandCreateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ brandCreateResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of brandCreateErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="update-brand-title" id="update-brand">
            <div class="section-heading">
              <p class="section-kicker">Update</p>
              <h2 id="update-brand-title">Update Brand</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to update an existing brand owned by the API-key account. Send only the fields that
              need to change. The same <code>brandId</code> stays reusable in later document, template, and sender
              identity requests.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of brandUpdateChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="brand-update-fields-title">
              <h3 id="brand-update-fields-title">Request fields</h3>
              <div class="field-list">
                @for (item of brandUpdateFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ brandUpdateEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Request body</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ brandUpdateRequestExample }}</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example response</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ brandUpdateResponseExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of brandUpdateErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="delete-brand-title" id="delete-brand">
            <div class="section-heading">
              <p class="section-kicker">Delete</p>
              <h2 id="delete-brand-title">Delete Brand</h2>
            </div>

            <p class="section-copy">
              Use this endpoint to permanently delete an existing brand owned by the API-key account. Deleted brands
              cannot be retrieved afterward, and any saved brand email-template overrides tied to that brand are removed
              as part of the delete operation.
            </p>

            <div class="info-grid info-grid--compact">
              @for (item of brandDeleteChecklist; track item.title) {
                <article class="info-card">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>

            <section class="reference-card" aria-labelledby="brand-delete-fields-title">
              <h3 id="brand-delete-fields-title">Request reference</h3>
              <div class="field-list">
                @for (item of brandDeleteFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Endpoint and auth</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>{{ brandDeleteEndpointExample }}</code></pre>
              </article>

              <article class="code-card">
                <div class="code-card-header">
                  <h3>Response</h3>
                  <span class="code-chip">HTTP</span>
                </div>
                <pre><code>204 No Content</code></pre>
              </article>
            </div>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Error responses</h3>
                  <span class="code-chip">Notes</span>
                </div>
                <div class="field-list">
                  @for (item of brandDeleteErrorNotes; track item.title) {
                    <article class="field-row">
                      <div class="field-row-heading">
                        <code>{{ item.title }}</code>
                      </div>
                      <p>{{ item.detail }}</p>
                    </article>
                  }
                </div>
              </article>
            </div>
          </section>
        </article>
      }

      @if (activeSection === 'webhooks') {
        <article class="docs-article" data-section="webhooks">
          <header class="article-header" id="webhooks-overview">
            <p class="eyebrow">API Reference</p>
            <h1>Webhooks</h1>
            <p class="article-intro">
              Subscribe to webhook events when you need document, sender-identity, and template lifecycle updates
              pushed out of the signing workflow. The examples below document the actual emitted payloads used by the
              backend today.
            </p>

            <div class="overview-list" aria-label="Webhook overview">
              @for (item of webhookOverviewCards; track item.title) {
                <article class="overview-item">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.detail }}</p>
                </article>
              }
            </div>
          </header>

          <section class="docs-section" aria-labelledby="webhook-envelope-title">
            <div class="section-heading">
              <p class="section-kicker">Envelope</p>
              <h2 id="webhook-envelope-title">Shared webhook envelope</h2>
            </div>

            <p class="section-copy">
              Every queued webhook delivery uses the same outer envelope. Event-specific fields live inside
              <code>data</code>, while <code>subject</code> points back to the document, sender identity, or template
              that raised the event.
            </p>

            <section class="reference-card" aria-labelledby="webhook-envelope-fields-title">
              <h3 id="webhook-envelope-fields-title">Envelope fields</h3>
              <div class="field-list">
                @for (item of webhookEnvelopeFields; track item.field) {
                  <article class="field-row">
                    <div class="field-row-heading">
                      <code>{{ item.field }}</code>
                      <span class="field-badge" [class.field-badge--required]="item.status === 'Required'" [class.field-badge--optional]="item.status === 'Optional'" [class.field-badge--generated]="item.status === 'Auto-generated'">
                        {{ item.status }}
                      </span>
                    </div>
                    <p>{{ item.detail }}</p>
                  </article>
                }
              </div>
            </section>

            <div class="code-grid">
              <article class="code-card">
                <div class="code-card-header">
                  <h3>Example envelope</h3>
                  <span class="code-chip">JSON</span>
                </div>
                <pre><code>{{ webhookEnvelopeExample }}</code></pre>
              </article>
            </div>
          </section>

          <section class="docs-section" aria-labelledby="document-events-title" id="document-events">
            <div class="section-heading">
              <p class="section-kicker">Family</p>
              <h2 id="document-events-title">Document Events</h2>
            </div>

            <p class="section-copy">
              Document webhook events cover draft creation, active signing actions, reminders, delivery failures,
              terminal status changes, and final completion after final PDF generation is done.
            </p>

            <div class="event-grid">
              @for (event of documentWebhookEvents; track event.event) {
                <section class="reference-card">
                  <h3><code>{{ event.event }}</code></h3>
                  <p>{{ event.meaning }}</p>
                  <p><strong>Subject:</strong> {{ event.subject }}</p>
                  @if (event.notes) {
                    <p><strong>Notes:</strong> {{ event.notes }}</p>
                  }
                  <div class="code-card code-card--inline">
                    <div class="code-card-header">
                      <h4>Payload `data`</h4>
                      <span class="code-chip">JSON</span>
                    </div>
                    <pre><code>{{ event.payload }}</code></pre>
                  </div>
                </section>
              }
            </div>
          </section>

          <section class="docs-section" aria-labelledby="sender-identity-events-title" id="sender-identity-events">
            <div class="section-heading">
              <p class="section-kicker">Family</p>
              <h2 id="sender-identity-events-title">Sender Identity Events</h2>
            </div>

            <p class="section-copy">
              Sender identity webhook events cover creation, metadata updates, approval outcomes, revocation, and
              deletion. Resend-only flows do not publish a dedicated webhook.
            </p>

            <div class="event-grid">
              @for (event of senderIdentityWebhookEvents; track event.event) {
                <section class="reference-card">
                  <h3><code>{{ event.event }}</code></h3>
                  <p>{{ event.meaning }}</p>
                  <p><strong>Subject:</strong> {{ event.subject }}</p>
                  @if (event.notes) {
                    <p><strong>Notes:</strong> {{ event.notes }}</p>
                  }
                  <div class="code-card code-card--inline">
                    <div class="code-card-header">
                      <h4>Payload `data`</h4>
                      <span class="code-chip">JSON</span>
                    </div>
                    <pre><code>{{ event.payload }}</code></pre>
                  </div>
                </section>
              }
            </div>
          </section>

          <section class="docs-section" aria-labelledby="template-events-title" id="template-events">
            <div class="section-heading">
              <p class="section-kicker">Family</p>
              <h2 id="template-events-title">Template Events</h2>
            </div>

            <p class="section-copy">
              Template webhook events cover template lifecycle updates and template-origin send failures. The
              `template.send_failed` event is emitted only when a document created from that template reaches the worker
              failure path.
            </p>

            <div class="event-grid">
              @for (event of templateWebhookEvents; track event.event) {
                <section class="reference-card">
                  <h3><code>{{ event.event }}</code></h3>
                  <p>{{ event.meaning }}</p>
                  <p><strong>Subject:</strong> {{ event.subject }}</p>
                  @if (event.notes) {
                    <p><strong>Notes:</strong> {{ event.notes }}</p>
                  }
                  <div class="code-card code-card--inline">
                    <div class="code-card-header">
                      <h4>Payload `data`</h4>
                      <span class="code-chip">JSON</span>
                    </div>
                    <pre><code>{{ event.payload }}</code></pre>
                  </div>
                </section>
              }
            </div>
          </section>
        </article>
      }
    </main>

    <aside class="page-toc" aria-label="On this page">
      <div class="toc-card">
        <h2>On this page</h2>
        <nav>
          <ul class="toc-list">
            @for (item of pageSections; track item.label) {
              <li>
                <button
                  type="button"
                  class="toc-link toc-link--button"
                  [class.toc-link--active]="isPageSectionActive(item.targetId)"
                  (click)="selectPageSection(item.targetId)">
                  {{ item.label }}
                </button>
              </li>
            }
          </ul>
        </nav>
      </div>
    </aside>
  </div>
</section>
